import {call, put} from "redux-saga/effects";
import * as api from "services/api";
import {getErrorFromMessage} from "services/utils/utils";
import {doPayFailure, doPaySuccess} from "store/reducer/payments/pay/reducer";
import * as Stripe from "stripe.js";
import {PaymentMethod} from "mapping/payment_method";

export function* doPaySaga({payload}) {
    const {type, resource_id, payment_method, invoice} = payload;
    try {
        let card_id;
        if(!!payment_method.card) {
            const payload = {payload: {card: payment_method.card}};
            card_id = yield call(addPaymentMethodSaga, payload);
        } else {
            card_id = payment_method.stripe_id;
        }
        yield call([api, api.saveInvoicingData], invoice);
        const apiToCall = type === "video" ? api.unlockVideo : api.unlockDirectory;
        yield call([api, apiToCall], resource_id, {payment_id: card_id});
        yield put(doPaySuccess());
    } catch (e) {
        console.log(e);
        yield put(doPayFailure(getErrorFromMessage(e)));
    }
}

export function* addPaymentMethodSaga({payload}) {
    const {card} = payload;
    const stripe = yield Stripe.StripePromise;
    const {paymentMethod} = yield call(stripe.createPaymentMethod, {
        type: "card",
        card: card
    });
    const method = PaymentMethod.fromStripe(paymentMethod);
    const result = yield call([api, api.addPaymentMethodApi], method);
    if(result.data && result.data.requires_action) {
        const { error: errorAction } = yield call(stripe.confirmCardSetup, result.data.payment_intent_client_secret);
        if(errorAction) {
            // eslint-disable-next-line no-throw-literal
            throw ({ response : { data: { errors: [errorAction] } } });
        } else {
            yield call([api, api.addPaymentMethodApi], method);
            return method.stripe_id;
        }
    } else {
        return method.stripe_id;
    }
}